import api from '@/utils/api'

export const registerRunnerSelf = (obj) => {
  return api.post('/users/registration/runner_self/', obj)
    .then(resp => {
      return (resp.data)
    })
}

export const accountConfirmEmail = (token) => {
  return api.post('/users/verify-email/runner_self/', {key: token})
    .then(resp => {
      return (resp.data)
    })
}

export const accountRunnerAdminConfirmEmail = (data) => {
  return api.post('/users/verify-email/runner/', data)
    .then(resp => {
      return (resp.data)
    })
}

export const accountTrainerAdminConfirmEmail = (data) => {
  return api.post('/users/verify-email/trainer/', data)
    .then(resp => {
      return (resp.data)
    })
}

export const passwordReset = (email) => {
  return api.post('/users/password/reset/', {email: email})
    .then(resp => {
      return (resp.data)
    })
}

export const passwordResetConfirm = (data) => {
  return api.post('/users/password/reset-confirm/', data)
    .then(resp => {
      return (resp.data)
    })
}

export const passwordChange = (data) => {
  return api.post('/rest-auth/password/change/', data)
    .then(resp => {
      return (resp.data)
    })
}

export const login = (user) => {
  return api.post('/rest-auth/login/', user)
}

export const user = () => {
  return api.get('/user/')
}



// WEBPACK FOOTER //
// ./src/auth/api.js